window.addEventListener(
  "load",
  function () {
    if (document.querySelector(".accordion")) {
      const accordions = document.querySelectorAll(".accordion");

      accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll(".accordion-item");

        items.forEach((item) => {
          const trigger = item.querySelector(".accordion-trigger");
          const panel = item.querySelector(".accordion-panel");

          if (!trigger || !panel) return;

          trigger.addEventListener("click", () => {
            const isOpen = item.classList.contains("is-open");

            if (isOpen) {
              // closing
              panel.style.maxHeight = panel.scrollHeight + "px"; // set current height
              requestAnimationFrame(() => {
                panel.style.maxHeight = "0px";
              });
            } else {
              // opening
              panel.style.maxHeight = panel.scrollHeight + "px";
            }

            item.classList.toggle("is-open");
            trigger.setAttribute("aria-expanded", String(!isOpen));
            panel.setAttribute("aria-hidden", String(isOpen));
          });
        });
      });
    }
  },
  false,
);
